export default {
  autocomplete: {
    width: '100%',
    minWidth: '150px',
    border: 0,
    fontSize: '14px',
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: 0,
      border: 'none',
    },
    '& .MuiInputBase-input': {
      fontSize: '14px',
    },
    '& .MuiInput-root::before': {
      display: 'none',
    },
    '& .MuiInput-root::after': {
      display: 'none',
    },
  },
  wrapper: {
    width: '100%',
    '& .MuiAutocomplete-popper': {
      border: 'none',
      fontSize: '14px',

      boxShadow: (theme) => theme.customShadows.lightShadow,
      borderRadius: '8px',
      backgroundColor: '#fff!important',
      padding: '32px 0',

      ul: {
        padding: '0 32px',
      },
      li: {
        color: (theme) => theme.palette.grays.gray700,
        fontSize: '0.875rem',
        padding: '8px!important',
        marginBottom: '8px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        borderRadius: '8px',

        '&.Mui-selected': {
          color: '#fff',
          backgroundColor: (theme) =>
            `${theme.palette.blues.primaryBlue500}!important`,
        },

        '&:hover': {
          color: '#fff',
          backgroundColor: (theme) =>
            `${theme.palette.blues.primaryBlue500}!important`,
        },
      },
    },
  },
};
